/**
 * Deterministic seeded RNG (mulberry32).
 *
 * The authoritative sim and the client's prediction must produce identical
 * results from identical inputs, so we never use Math.random() inside the sim.
 * Instead every match seeds one of these and advances it in lock-step.
 */
export interface Rng {
  state: number;
}

export const createRng = (seed: number): Rng => ({ state: seed >>> 0 });

/** Advances the RNG and returns a float in [0, 1). Mutates `rng.state`. */
export const nextFloat = (rng: Rng): number => {
  let t = (rng.state += 0x6d2b79f5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

/** Integer in [min, max) using the seeded stream. */
export const nextInt = (rng: Rng, min: number, max: number): number =>
  min + Math.floor(nextFloat(rng) * (max - min));
